import { compact } from 'lodash';
import { useMemo } from 'react';

import { PatientConsentDocument } from '@dreryk/egabinet-patient-frontend-api';

import { TableDataAccessor } from '@dreryk/react-components';

import { VisitStatusResolver } from '../../../shared/VisitStatusResolver/VisitStatusResolver';

export const ConsentsAndAuthorizationsTableDataAccessor: TableDataAccessor<PatientConsentDocument> = (props) => {
   const visitIds = useMemo<number[]>(() => {
      return compact(props.currentPage.map((patientConsentDocument) => patientConsentDocument.createdOnVisitId));
   }, [props.currentPage]);

   return <VisitStatusResolver visitIds={visitIds} />;
};
